import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M14.594 2.906H1.406C.631 2.906 0 3.537 0 4.312v9.375c0 .776.63 1.407 1.406 1.407h13.188c.775 0 1.406-.631 1.406-1.406V4.313c0-.776-.63-1.407-1.406-1.407m.469 10.782a.47.47 0 0 1-.47.468H1.407a.47.47 0 0 1-.468-.469V4.313a.47.47 0 0 1 .468-.47h13.188a.47.47 0 0 1 .469.47z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M6.924 6.281h-4.66a.39.39 0 0 0-.389.389v4.66c0 .215.174.389.388.389h4.661a.39.39 0 0 0 .388-.389V6.67a.39.39 0 0 0-.388-.389m-.388.777v3.667H2.652V7.058zM13.658 6.625H9.845a.469.469 0 0 0 0 .938h3.813a.469.469 0 0 0 0-.938M13.658 8.5H9.845a.469.469 0 0 0 0 .938h3.813a.469.469 0 0 0 0-.938M13.658 10.375H9.845a.469.469 0 0 0 0 .938h3.813a.469.469 0 0 0 0-.938"
    }, null, -1)
  ]))]))
}
export default { render: render }